(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticker-slap reveals
  var els = document.querySelectorAll('[data-mynd-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // One-tap add by size
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mynd-add]');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var label = chip.textContent;
    chip.disabled = true;
    chip.classList.add('is-loading');
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +chip.getAttribute('data-mynd-add'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      chip.classList.remove('is-loading');
      chip.classList.add('is-added');
      chip.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('mynd:added'));
      if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') theme.ajaxCart.update();
      if (window.theme && theme.RightDrawer && typeof theme.RightDrawer.open === 'function') theme.RightDrawer.open();
      setTimeout(function () {
        chip.textContent = label;
        chip.classList.remove('is-added');
        chip.disabled = false;
      }, 1800);
    }).catch(function () {
      chip.classList.remove('is-loading');
      chip.textContent = 'Sold out';
    });
  });

  // Size sheet: one clean picker instead of a wall of size buttons on every card
  var sheet = null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function closeSheet() { if (sheet) sheet.hidden = true; }
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'mqs-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="mqs-sheet__backdrop" data-sheet-close></div>' +
      '<div class="mqs-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="MqsSheetTitle">' +
      '<button type="button" class="mqs-sheet__close" data-sheet-close aria-label="Close">&times;</button>' +
      '<p class="mqs-sheet__title" id="MqsSheetTitle"></p><p class="mqs-sheet__price"></p>' +
      '<div class="mqs-sheet__body"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    document.addEventListener('mynd:added', function () { setTimeout(closeSheet, 450); });
    return sheet;
  }
  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
  function openSheet(d) {
    ensureSheet();
    var opts = d.options || [];
    var sizeIdx = 0;
    opts.forEach(function (o, i) { if (/size|waist|length/i.test(o)) sizeIdx = i; });
    var otherIdx = opts.length === 2 ? 1 - sizeIdx : -1;
    var flat = opts.length > 2;
    var others = otherIdx >= 0 ? uniq(d.variants.map(function (v) { return v.o[otherIdx]; })) : [];
    var sel = others.filter(function (val) { return d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; }); })[0] || others[0];
    sheet.querySelector('.mqs-sheet__title').textContent = d.title;
    var cents = +d.price || 0, dollars = (cents / 100).toFixed(2);
    sheet.querySelector('.mqs-sheet__price').textContent = '$' + (dollars.slice(-3) === '.00' ? dollars.slice(0, -3) : dollars);
    var body = sheet.querySelector('.mqs-sheet__body');
    function render() {
      var html = '';
      if (otherIdx >= 0) {
        html += '<p class="mqs-sheet__label">' + esc(opts[otherIdx]) + '</p><div class="mqs-sheet__pills">' +
          others.map(function (val) {
            var any = d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; });
            return '<button type="button" class="mqs-sheet__pill' + (val === sel ? ' is-on' : '') + (any ? '' : ' is-out') + '" data-pill="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('') + '</div>';
      }
      var list = flat ? d.variants.map(function (v) { return { label: v.o.join(' / '), v: v }; }) :
        uniq(d.variants.map(function (v) { return v.o[sizeIdx]; })).map(function (size) {
          var v = d.variants.filter(function (x) { return x.o[sizeIdx] === size && (otherIdx < 0 || x.o[otherIdx] === sel); })[0];
          return v ? { label: size, v: v } : null;
        }).filter(Boolean);
      html += '<p class="mqs-sheet__label">' + esc(flat ? 'Option' : (opts[sizeIdx] || 'Size')) + '</p><div class="mqs-sheet__grid' + (flat ? ' is-flat' : '') + '">' +
        list.map(function (it) {
          return it.v.a ? '<button type="button" class="mqs-sheet__size" data-mynd-add="' + it.v.id + '">' + esc(it.label) + '</button>' :
            '<button type="button" class="mqs-sheet__size is-out" disabled aria-label="' + esc(it.label) + ', sold out">' + esc(it.label) + '</button>';
        }).join('') + '</div>';
      if (list.some(function (it) { return !it.v.a; })) html += '<p class="mqs-sheet__legend"><span></span>Sold out</p>';
      body.innerHTML = html;
      body.querySelectorAll('[data-pill]').forEach(function (p) {
        p.addEventListener('click', function () { sel = p.getAttribute('data-pill'); render(); });
      });
    }
    render();
    sheet.hidden = false;
    var first = sheet.querySelector('.mqs-sheet__size:not([disabled])') || sheet.querySelector('.mqs-sheet__close');
    if (first) first.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mqs-open]');
    if (!btn) return;
    e.preventDefault();
    var json = btn.parentNode.querySelector('[data-mqs-json]');
    if (!json) return;
    try { openSheet(JSON.parse(json.textContent)); } catch (err) {}
  });

  // Mobile "Shop the drop" bar hides once the shop rail is on screen or passed
  var bar = document.querySelector('[data-mynd-shopbar]');
  var target = document.getElementById('MyndQuickShop');
  if (bar && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.classList.toggle('is-hidden', en.isIntersecting || en.boundingClientRect.top < 0);
    }).observe(target);
  } else if (bar) {
    bar.classList.add('is-hidden');
  }
})();
